import React from "react";
// import { List, Modal, Picker, Toast, ImagePicker, InputItem, Button, Flex,SearchBar } from 'antd-mobile';
import { post } from "../../utils/request";
import api from "../api";

import "./index.less";

class ActivityModuleRule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detailData: {},
      urlOps: {},
    };
  }
  componentDidMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] = obj1[i].split("=")[1];
      }
      this.setState(
        {
          urlOps: ops,
        },
        () => {
          post({
            url:
              api.selectMarketingRule +
              "?app_stoken=" +
              this.state.urlOps.app_stoken,
            data: {
              activityCode: this.state.urlOps.activityCode,
            },
          }).then((res) => {
            if (!(res && res.data)) {
              return;
            }
            this.setState({
              detailData: res.data,
            });
          });
        }
      );
    }
  }

  render() {
    const { detailData } = this.state;
    return (
      <div
        className="ActivityModuleRule"
        style={{ background: this.state.urlOps.color || "#fff" }}
      >
        <div>
          <div dangerouslySetInnerHTML={{ __html: detailData }}></div>
        </div>
      </div>
    );
  }
}
export default ActivityModuleRule;



// WEBPACK FOOTER //
// ./src/ActivityModule/rule/index.js